import { pathJoin } from 'src/reducers/routing/utils'

export const createWeightControlRouteMap = (prefix: string) => ({
  'need-approval': pathJoin(prefix)('need-approval').chain,
  'awaiting-completion': pathJoin(prefix)('awaiting-completion').chain,
  completed: pathJoin(prefix)('completed').chain,
  // COMPASS-877 / HSY REQ 18: the office match queue for weighings pushed by
  // an unloading site's weighing system.
  'weigh-tickets': pathJoin(prefix)('weigh-tickets').chain,
})
